import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import FileImport from "components/FileImport";
import Switch from "components/Switch";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { importDictionaryFromArchive } from "slices/dictionary/actions/dictionary";

export const dictionaryExtension = {
  xml: "xml",
  csv: "csv",
};
const ImportDictionaryModal = ({ navigate }) => {
  const dispatch = useDispatch();
  const [okButtonDisabled, setOkButtonDisabled] = useState(true);
  const [selectedFile, setSelectedFile] = useState("");
  const [fileExtension, setFileExtension] = useState(dictionaryExtension.xml);
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!okButtonDisabled) {
      const formData = new FormData();
      formData.append("importedFile", selectedFile, selectedFile.name);
      if (fileExtension === dictionaryExtension.csv) {
        formData.append("dictionaryName", selectedFile.name.slice(0, -4));
      }
      dispatch(importDictionaryFromArchive(formData, navigate, fileExtension));
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter" && !okButtonDisabled) {
      handleSubmit();
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.IMPORT_DICTIONARY));
  };

  const handleSwitch = () => {
    setSelectedFile("");
    if (fileExtension === dictionaryExtension.csv) {
      setFileExtension(dictionaryExtension.xml);
    } else {
      setFileExtension(dictionaryExtension.csv);
    }
  };

  useEffect(() => {
    if (selectedFile && selectedFile.name.endsWith(fileExtension)) {
      setOkButtonDisabled(false);
      setError("");
    } else {
      setOkButtonDisabled(true);
      if (selectedFile) {
        setError(
          `You can only upload ${fileExtension.replace(
            ".",
            ""
          )} files. Please chose a file with the extension '${fileExtension}'`
        );
      }
    }
  }, [selectedFile]);

  useEffect(() => {
    setError("");
  }, [fileExtension]);

  const fileTypeSwitch = () => (
    <div className="import_dictionary__body__file_type">
      <span>File Type</span>
      <div>
        <span
          className={`${
            fileExtension === dictionaryExtension.csv ? "active" : "inactive"
          }`}
        >
          Import CSV
        </span>
        <Switch
          handleChange={handleSwitch}
          currentSwitchState={fileExtension !== dictionaryExtension.csv}
          id="export-content-xlsx-switch"
        />

        <span
          className={`${
            fileExtension === dictionaryExtension.xml ? "active" : "inactive"
          }`}
        >
          Import Archive (xml)
        </span>
      </div>
    </div>
  );

  const modalBody = () => (
    <div className="import_dictionary__body">
      {fileTypeSwitch()}
      <div className="import_file">
        <FileImport
          accepts={`.${fileExtension}`}
          handleFileChange={handleFileChange}
          selectedFile={selectedFile}
          error={error}
        />
      </div>
    </div>
  );

  return (
    <Modal
      data-test="importDictionaryModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header>
        <b className="import_dictionary__header">Import Dictionary</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="cancelButton"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="importButton"
          variant={NewButtonVariant.l1}
          onClick={handleSubmit}
          disabled={selectedFile === "" || error !== ""}
        >
          Import
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportDictionaryModal;

ImportDictionaryModal.propTypes = {
  navigate: PropTypes.func,
};
